import { render, staticRenderFns } from "./orderTop.vue?vue&type=template&id=4c35476c&scoped=true&"
import script from "./orderTop.vue?vue&type=script&lang=js&"
export * from "./orderTop.vue?vue&type=script&lang=js&"
import style0 from "./orderTop.vue?vue&type=style&index=0&id=4c35476c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c35476c",
  null
  
)

export default component.exports